import { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { Link } from "react-router-dom";
import "./styles.css";
import { db } from "../../utils/firebase";

function About() {
  const [aboutText, setAboutText] = useState("");

  useEffect(() => {
    const fetchAboutText = async () => {
      const docRef = doc(db, "bio", "aboutMe");
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        setAboutText(docSnap.data().desc.toLowerCase());
      } else {
        console.log("No such document!");
      }
    };

    fetchAboutText();
  }, []);

  return (
    <div className="aboutContainer">
      <div dangerouslySetInnerHTML={{ __html: aboutText }} />
      <Link to={"/"} className="homeLink">
        home
      </Link>
    </div>
  );
}

export default About;
